export const translations = {
  pt: {
    nav: {
      home: "Início",
      therapists: "Massagistas",
      massages: "Massagens",
      about: "O Espaço",
      contact: "Contactos",
      book: "Agendar",
      allTherapists: "Ver todas as massagistas",
      allMassages: "Ver todas as massagens",
      applications: "Candidaturas",
      promotions: "Promoções",
      prices: "Preços",
    },
    hero: {
      label: "MAGNOLIA LUNAR • LISBOA",
      title1: "Um refúgio para",
      title2: "os seus sentidos",
      subtitle: "Massagens sensoriais em ambiente reservado e sofisticado. Um dia relaxante para corpo, mente e sentidos.",
      ctaBook: "Agendar Experiência",
      ctaExplore: "Explorar Massagens",
      scroll: "Deslize para descobrir",
    },
    team: {
      label: "EQUIPA",
      title: "As Nossas Terapeutas",
      subtitle: "Profissionais dedicadas a proporcionar uma experiência única de relaxamento e ligação.",
      viewAll: "Conhecer Toda a Equipa",
      bookWith: "Agendar com",
      viewProfile: "Ver Perfil",
      availableToday: "Disponível Hoje",
    },
    services: {
      label: "OS NOSSOS SERVIÇOS",
      title: "Experiências Sensoriais",
      subtitle: "Um menu de massagens exclusivas, desenhado para despertar os sentidos.",
      viewAll: "Ver Todas as Massagens",
      details: "Ver Detalhes",
      book: "Agendar",
      availableWith: "Disponível com",
    },
    essence: {
      label: "A NOSSA ESSÊNCIA",
      title1: "Onde o tempo",
      title2: "abranda",
      p1: "O Magnolia Lunar não é apenas um spa, é um refúgio sensorial no coração de Lisboa. Criámos um santuário onde a elegância encontra o relaxamento profundo, longe do ruído da cidade.",
      p2: "Cada terapia é uma obra de arte executada por terapeutas selecionadas, combinando técnicas milenares com um toque contemporâneo e intuitivo. Aqui, o luxo reside na privacidade e na atenção aos detalhes.",
      privacy: "Privacidade",
      privacyDesc: "Suites acústicas e discretas",
      comfort: "Conforto",
      comfortDesc: "Duche privativo premium",
      cta: "Conheça o Espaço",
    },
    testimonials: {
      title: "O que dizem os nossos clientes",
      items: [
        { text: "Uma experiência transcendental. O ambiente é impecável e a terapeuta foi extremamente profissional e atenciosa. Recomendo vivamente.", author: "João M." },
        { text: "A melhor massagem que já fiz em Lisboa. O espaço é muito discreto e limpo. A massagem tântrica foi uma descoberta incrível.", author: "Ricardo S." },
        { text: "Profissionalismo e simpatia desde o primeiro contacto. Senti-me muito à vontade e relaxado. Voltarei com certeza.", author: "Pedro L." },
      ],
    },
    contact: {
      label: "ENTRE EM CONTACTO",
      title: "Agende o seu momento de paz",
      subtitle: "Estamos prontos para recebê-lo no nosso santuário. Tire as suas dúvidas ou agende a sua visita pelo WhatsApp ou telefone.",
      location: "Localização",
      locationValue: "Av. Fontes Pereira de Melo 35",
      locationNote: "1050-118 Lisboa, Portugal",
      phone: "Telefone / WhatsApp",
      phoneHours: "Atendimento das 10h às 22h",
      email: "Email",
      readyTitle: "Pronto para relaxar?",
      readyDesc: "Clique no botão abaixo para iniciar uma conversa direta pelo WhatsApp. A nossa equipa responderá o mais breve possível para confirmar a sua reserva.",
      whatsappCta: "Agendar pelo WhatsApp",
      availability: "Disponibilidade Hoje",
      fewSlots: "Poucas vagas restantes",
    },
    booking: {
      title: "Agendar Experiência",
      subtitle: "Escolha a sua massagista e a massagem. Abriremos uma conversa no WhatsApp com tudo preparado.",
      stepTherapist: "Escolha a massagista",
      stepMassage: "Escolha a massagem",
      optional: "opcional",
      openWhatsApp: "Abrir WhatsApp",
      selectFirst: "Selecione uma massagista para continuar",
      message: (therapist, massage) =>
        massage
          ? `Olá! Gostaria de agendar uma ${massage} com a massagista ${therapist}. Qual a disponibilidade?`
          : `Olá! Gostaria de agendar uma sessão com a massagista ${therapist}. Qual a disponibilidade?`,
      generalMessage: "Olá! Gostaria de saber mais informações sobre as massagens.",
    },
    about: {
      label: "O NOSSO SANTUÁRIO",
      title: "Conheça o Espaço",
      subtitle: "Um refúgio desenhado para proporcionar privacidade, conforto e uma imersão sensorial completa. Cada detalhe foi pensado para o seu relaxamento.",
      howTitle: "Como Funciona",
      steps: [
        { title: "Escolha a sua Experiência", desc: "Navegue pelas nossas massagens e conheça as nossas terapeutas para encontrar a combinação perfeita para o seu momento." },
        { title: "Agende com Discrição", desc: "Entre em contacto via WhatsApp. A nossa equipa confirmará a disponibilidade e fornecerá todos os detalhes necessários." },
        { title: "Relaxe Profundamente", desc: "Ao chegar, desligue-se do mundo exterior. Desfrute de um ambiente seguro, limpo e preparado para o seu bem-estar." },
      ],
      chooseTherapist: "Escolha a sua Terapeuta",
      chooseTherapistDesc: "Conheça algumas das nossas terapeutas disponíveis para tornar a sua experiência inesquecível.",
    },
    therapist: {
      back: "Voltar para Massagistas",
      about: "Sobre",
      gallery: "Galeria de Fotos",
      specialties: "Especialidades",
      bookWith: "Agende com",
      requestAvailability: "Solicitar Disponibilidade",
      age: "Idade",
      years: "anos",
      nationality: "Nacionalidade",
      hair: "Cabelo",
      eyes: "olhos",
      height: "Altura",
      weight: "Peso",
      availabilityMessage: (name) => `Olá, gostaria de saber a disponibilidade de ${name}.`,
    },
    massage: {
      back: "Voltar para Massagens",
      exclusive: "EXPERIÊNCIA EXCLUSIVA",
      specialists: "Terapeutas Especializadas",
      bookNow: "Agendar Agora",
      pageTitle: "Menu de Massagens",
    },
    therapistsPage: {
      label: "NOSSA EQUIPA",
      title: "Terapeutas",
      subtitle: "Conheça a nossa equipa de terapeutas especializadas em massagens sensoriais e tântricas.",
    },
    footer: {
      tagline: "Um refúgio sensorial no coração de Lisboa. Privacidade, requinte e relaxamento profundo.",
      navigation: "Navegação",
      massages: "Massagens",
      contact: "Contactos",
      hours: "Todos os dias • 10h – 22h",
      rights: "Todos os direitos reservados.",
      disclaimer: "Site reservado a maiores de 18 anos.",
      privacy: "Privacidade",
      cookies: "Cookies",
      terms: "Termos",
      prices: "Preços",
      promotions: "Promoções",
      applications: "Candidaturas",
      paymentsTitle: "Pagamentos",
    },
    whatsapp: {
      float: "Fale connosco no WhatsApp",
    },
    explore: {
      otherTherapists: "Outras Massagistas",
      otherMassages: "Outras Massagens",
      previous: "Anterior",
      next: "Seguinte",
      discoverMassages: "Explorar o Menu de Massagens",
      discoverMassagesDesc: "Tântrica, Nuru, Corpo a Corpo e mais — descubra a experiência perfeita para o seu momento.",
      discoverTherapists: "Conhecer as Terapeutas",
      discoverTherapistsDesc: "Escolha a profissional ideal para a sua experiência.",
      bookCta: "Agendar Experiência",
      bookCtaDesc: "Abrimos uma conversa no WhatsApp com tudo preparado.",
    },
    ageGate: {
      title: "Site Reservado a Maiores de 18",
      text: "Este website contém conteúdo destinado exclusivamente a adultos. Ao entrar, confirma que tem pelo menos 18 anos de idade.",
      confirm: "Tenho 18 anos ou mais — Entrar",
      exit: "Sair do site",
    },
    seo: {
      home: {
        title: "Magnolia Lunar | Spa de Massagens Tântricas em Lisboa",
        desc: "Um refúgio para os seus sentidos. Massagens tântricas e sensoriais em ambiente reservado e sofisticado no coração de Lisboa.",
      },
      therapists: {
        title: "Massagistas | Magnolia Lunar",
        desc: "Conheça a nossa equipa de terapeutas especializadas em massagens sensoriais e tântricas em Lisboa.",
      },
      massages: {
        title: "Menu de Massagens | Magnolia Lunar",
        desc: "Explore o nosso menu de massagens exclusivas em Lisboa: tântrica, nuru, corpo a corpo, 4 mãos e mais.",
      },
      about: {
        title: "O Espaço | Magnolia Lunar",
        desc: "Um santuário desenhado para privacidade, conforto e imersão sensorial completa no coração de Lisboa.",
      },
      contact: {
        title: "Contactos | Magnolia Lunar",
        desc: "Agende o seu momento de paz pelo WhatsApp ou telefone. Atendimento das 10h às 22h em Lisboa.",
      },
    },
    cookies: {
      title: "Este site usa cookies",
      body: "Utilizamos apenas cookies essenciais para o funcionamento do site e a segurança da sessão. Não usamos cookies publicitários nem partilhamos dados com terceiros para marketing.",
      accept: "Entendi",
      settings: "Detalhes",
      readMore: "Ler a Política de Cookies",
    },
    legal: {
      eyebrow: "AVISO LEGAL",
      lastUpdate: "Última atualização",
      updatedDate: "10 de Junho de 2026",
      privacy: {
        seoTitle: "Política de Privacidade | Magnolia Lunar",
        seoDesc: "Como o Magnolia Lunar Spa recolhe, utiliza e protege os seus dados pessoais em conformidade com o RGPD.",
        title: "Política de Privacidade",
        intro: "A sua privacidade é fundamental para o Magnolia Lunar Spa. Este documento explica que dados recolhemos, para que os usamos e quais os seus direitos ao abrigo do RGPD.",
        sections: [
          {
            heading: "1. Responsável pelo tratamento",
            paragraphs: [
              "O responsável pelo tratamento dos dados pessoais é o Magnolia Lunar Spa, com sede em Lisboa, Portugal.",
              "Para qualquer questão relacionada com dados pessoais pode contactar-nos através do email magnolialunarspa@gmail.com ou pelo WhatsApp +351 962 252 659.",
            ],
          },
          {
            heading: "2. Dados que recolhemos",
            paragraphs: [
              "Só recolhemos os dados estritamente necessários para prestar o serviço. Isto inclui: nome, telefone/WhatsApp e mensagens trocadas connosco quando faz uma reserva ou pedido de informação. Não pedimos morada, documentos de identificação nem dados de pagamento neste site.",
              "Ao usar o site podemos ainda recolher dados técnicos automáticos (endereço IP, tipo de navegador, páginas visitadas) exclusivamente para fins de segurança e diagnóstico.",
            ],
          },
          {
            heading: "3. Finalidades e base legal",
            paragraphs: [
              "Utilizamos os seus dados para: (i) responder a pedidos de informação e agendamento; (ii) confirmar a reserva e prestar o serviço; (iii) cumprir obrigações legais aplicáveis; (iv) garantir a segurança do site e prevenir fraude.",
              "As bases legais para o tratamento são a execução do contrato/pedido, o consentimento (sempre que aplicável) e o interesse legítimo do Magnolia Lunar em prestar um serviço seguro e de qualidade.",
            ],
          },
          {
            heading: "4. Partilha de dados",
            paragraphs: [
              "Não vendemos nem partilhamos os seus dados com terceiros para fins de marketing. As reservas são iniciadas através do WhatsApp; a comunicação nessa plataforma é regida pelas políticas da Meta Platforms Inc.",
              "Podemos partilhar dados com prestadores de serviços técnicos (alojamento, backups) sob acordos de confidencialidade, e apenas na medida do necessário.",
            ],
          },
          {
            heading: "5. Prazo de conservação",
            paragraphs: [
              "Conservamos os dados apenas durante o período necessário às finalidades para as quais foram recolhidos ou, quando aplicável, durante os prazos legais.",
              "Mensagens de agendamento e histórico de contactos são conservados até 24 meses após o último contacto, salvo obrigação legal em contrário.",
            ],
          },
          {
            heading: "6. Os seus direitos",
            paragraphs: [
              "Ao abrigo do RGPD tem direito a: aceder aos seus dados, retificá-los, apagá-los, opor-se ao tratamento, solicitar a limitação do tratamento e à portabilidade.",
              "Para exercer estes direitos contacte-nos através de magnolialunarspa@gmail.com. Tem ainda o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD — www.cnpd.pt).",
            ],
          },
          {
            heading: "7. Segurança",
            paragraphs: [
              "Adotamos medidas técnicas e organizativas adequadas para proteger os dados contra acesso não autorizado, alteração, divulgação ou destruição, incluindo comunicações cifradas (HTTPS) e controlo de acessos.",
            ],
          },
          {
            heading: "8. Alterações",
            paragraphs: [
              "Esta política pode ser atualizada periodicamente. A versão em vigor é sempre a publicada nesta página, com a data de última atualização.",
            ],
          },
        ],
      },
      cookies: {
        seoTitle: "Política de Cookies | Magnolia Lunar",
        seoDesc: "Que cookies o Magnolia Lunar Spa utiliza, para que servem e como gerir as suas preferências.",
        title: "Política de Cookies",
        intro: "Utilizamos apenas cookies essenciais para o funcionamento e a segurança do site. Não usamos cookies publicitários nem de perfilagem de terceiros.",
        sections: [
          {
            heading: "1. O que são cookies?",
            paragraphs: [
              "Cookies são pequenos ficheiros de texto que os websites colocam no seu dispositivo para funcionar corretamente, memorizar preferências ou recolher informação estatística.",
            ],
          },
          {
            heading: "2. Que cookies usamos?",
            paragraphs: [
              "Este site utiliza exclusivamente cookies estritamente necessários (essenciais) e não requer consentimento nos termos da legislação aplicável, embora o informemos por transparência.",
              "Não utilizamos cookies analíticos, publicitários ou de redes sociais.",
            ],
          },
          {
            heading: "3. Como gerir cookies?",
            paragraphs: [
              "Pode gerir ou apagar cookies em qualquer altura através das definições do seu navegador. Se bloquear cookies essenciais, algumas áreas do site (como o painel de administração) podem deixar de funcionar corretamente.",
            ],
          },
          {
            heading: "4. Cookies em detalhe",
            paragraphs: [
              "Segue-se a lista dos cookies e itens de armazenamento local utilizados por este site.",
            ],
          },
        ],
        tableName: "Nome",
        tablePurpose: "Finalidade",
        tableDuration: "Duração",
        tableType: "Tipo",
        table: [
          { name: "access_token", purpose: "Sessão autenticada no painel de administração (httpOnly)", duration: "15 minutos", type: "Essencial" },
          { name: "refresh_token", purpose: "Renovação da sessão de administração (httpOnly)", duration: "7 dias", type: "Essencial" },
          { name: "ml-lang", purpose: "Idioma preferido (PT/EN/ES) — localStorage", duration: "Persistente", type: "Essencial" },
          { name: "ml-theme", purpose: "Tema visual (claro/escuro) — localStorage", duration: "Persistente", type: "Essencial" },
          { name: "ml-age-ok", purpose: "Confirmação de que o utilizador tem 18+ — localStorage", duration: "Persistente", type: "Essencial" },
          { name: "ml-cookie-consent-v1", purpose: "Confirmação do aviso de cookies — localStorage", duration: "Persistente", type: "Essencial" },
        ],
      },
      terms: {
        seoTitle: "Termos e Condições | Magnolia Lunar",
        seoDesc: "Condições de utilização do site e das reservas efetuadas junto do Magnolia Lunar Spa.",
        title: "Termos e Condições",
        intro: "Ao utilizar este website aceita os termos e condições a seguir descritos. Se não concordar com qualquer parte, por favor não utilize o site.",
        sections: [
          {
            heading: "1. Objeto e âmbito",
            paragraphs: [
              "Este site é propriedade do Magnolia Lunar Spa, com sede em Lisboa, Portugal, e destina-se exclusivamente a maiores de 18 anos. Serve para apresentar os nossos serviços de massagens sensoriais e tântricas e permitir o contacto e agendamento.",
            ],
          },
          {
            heading: "2. Idade mínima (18+)",
            paragraphs: [
              "O acesso ao website e aos serviços é reservado a maiores de 18 anos. Ao entrar, confirma essa maioridade. Reservamo-nos o direito de recusar o serviço a quem não cumpra este requisito.",
            ],
          },
          {
            heading: "3. Natureza dos serviços",
            paragraphs: [
              "As massagens praticadas no Magnolia Lunar são de natureza sensorial, relaxante e tântrica. Não são serviços sexuais, de acompanhamento ou prostituição. Qualquer interpretação em contrário é da exclusiva responsabilidade do visitante.",
            ],
          },
          {
            heading: "4. Agendamento e cancelamento",
            paragraphs: [
              "As reservas são efetuadas por WhatsApp e ficam confirmadas apenas após validação pela nossa equipa. Poderá ser solicitada a remarcação em caso de indisponibilidade da terapeuta escolhida.",
              "Pedimos que cancelamentos sejam comunicados com pelo menos 3 horas de antecedência.",
            ],
          },
          {
            heading: "5. Comportamento no espaço",
            paragraphs: [
              "É exigido respeito e educação para com todas as terapeutas e colaboradores. Qualquer comportamento inadequado, ofensivo ou que ultrapasse os limites do serviço prestado dará origem à interrupção imediata do serviço, sem direito a reembolso.",
            ],
          },
          {
            heading: "6. Propriedade intelectual",
            paragraphs: [
              "Todo o conteúdo do site (textos, imagens, logótipo, marca, código) é propriedade do Magnolia Lunar Spa ou dos respetivos titulares. É proibida a reprodução total ou parcial sem autorização escrita.",
            ],
          },
          {
            heading: "7. Limitação de responsabilidade",
            paragraphs: [
              "O Magnolia Lunar esforça-se por manter as informações do site corretas e atualizadas, mas não garante a ausência de erros, atrasos ou interrupções. Não nos responsabilizamos por danos resultantes do uso ou impossibilidade de uso do site.",
            ],
          },
          {
            heading: "8. Lei aplicável e foro",
            paragraphs: [
              "Estes termos regem-se pela lei portuguesa. Para dirimir qualquer litígio, as partes elegem o foro da Comarca de Lisboa, com renúncia expressa a qualquer outro.",
            ],
          },
        ],
      },
    },
    applications: {
      label: "JUNTA-TE A NÓS",
      title: "Quer trabalhar connosco?",
      subtitle: "Junte-se à equipa do Magnolia Lunar Spa. Damos formação nas nossas massagens.",
      whatsapp: "Envie-nos mensagem via WhatsApp",
      formTitle: "Ou preencha o formulário abaixo",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      message: "Mensagem",
      messagePlaceholder: "Conte-nos um pouco sobre si (idade, experiência, disponibilidade...)",
      photo1: "Fotografia 1 (rosto)",
      photo2: "Fotografia 2 (corpo inteiro)",
      photo3: "Fotografia 3 ou CV",
      photoHint: "Máx. 10 MB por ficheiro",
      submit: "Enviar candidatura",
      submitting: "A enviar...",
      successTitle: "Candidatura enviada!",
      successText: "Obrigado pelo interesse. Iremos analisar a sua candidatura e entrar em contacto brevemente.",
      profileTitle: "O que procuramos",
      profileText: "O Magnolia Lunar Spa é dedicado à massagem sensorial e tântrica. Os nossos clientes são mulheres, homens e casais, que nos procuram para relaxarem numa experiência única.",
      profileBullets: [
        "Com ou sem experiência prévia em massagem",
        "Mente aberta e orientada para um serviço de 5 estrelas",
        "Boa apresentação física",
        "Boa capacidade de aprendizagem",
        "Discrição e profissionalismo",
      ],
      profileClose: "Se tem este perfil, venha trabalhar connosco.",
      requiredError: "Por favor preencha todos os campos obrigatórios.",
      emailError: "Email inválido.",
      phoneError: "Telefone inválido. Introduza 9 dígitos começando por 9.",
      phoneHint: "9 dígitos, ex: 912345678",
      sendError: "Não foi possível enviar a candidatura. Tente novamente.",
    },
    promotions: {
      label: "PROMOÇÕES E NEWSLETTER",
      title: "Promoções exclusivas",
      subtitle: "Indique o seu email e receba as nossas promoções.",
      emailPlaceholder: "O seu email",
      subscribe: "Subscrever",
      subscribing: "A subscrever...",
      successTitle: "Subscrição confirmada!",
      successText: "Bem-vindo(a) à newsletter do Magnolia Lunar. Fique atento à sua caixa de entrada.",
      alreadyText: "Este email já se encontra subscrito.",
      benefitsTitle: "O que recebe ao subscrever",
      benefits: [
        "Descontos exclusivos em massagens relaxantes, tântricas e sensoriais",
        "Promoções especiais em pacotes de massagem para casal ou individual",
        "Novidades antecipadas sobre tratamentos e serviços",
        "Convites para eventos e experiências de bem-estar únicas",
      ],
      privacyNote: "A sua privacidade é respeitada. Pode remover o seu email a qualquer momento.",
      emailError: "Email inválido.",
      sendError: "Não foi possível subscrever. Tente novamente.",
    },
    prices: {
      label: "TABELA DE PREÇOS",
      title: "Preços",
      subtitle: "Serviço personalizado de 5 estrelas, num ambiente moderno e discreto.",
      individualTitle: "Massagens individuais",
      individualFrom: "Desde",
      individualPrice: "40€",
      coupleTitle: "Massagens de casal",
      coupleFrom: "Desde",
      couplePrice: "250€",
      note: "Temos muitas combinações de preços de massagens e complementos, com promoções em vigor. Para saber mais detalhes ou agendar, contacte-nos por WhatsApp ou telefone.",
      ctaWhatsapp: "Falar por WhatsApp",
      paymentsTitle: "Métodos de pagamento aceites",
      viewMassages: "Ver todas as massagens",
    },
  },

  en: {
    nav: {
      home: "Home",
      therapists: "Masseuses",
      massages: "Massages",
      about: "The Space",
      contact: "Contact",
      book: "Book Now",
      allTherapists: "View all masseuses",
      allMassages: "View all massages",
      applications: "Careers",
      promotions: "Promotions",
      prices: "Prices",
    },
    hero: {
      label: "MAGNOLIA LUNAR • LISBON",
      title1: "A refuge for",
      title2: "your senses",
      subtitle: "Sensory massages in a private and sophisticated setting. A relaxing day for body, mind and senses.",
      ctaBook: "Book an Experience",
      ctaExplore: "Explore Massages",
      scroll: "Scroll to discover",
    },
    team: {
      label: "TEAM",
      title: "Our Therapists",
      subtitle: "Professionals dedicated to providing a unique experience of relaxation and connection.",
      viewAll: "Meet the Whole Team",
      bookWith: "Book with",
      viewProfile: "View Profile",
      availableToday: "Available Today",
    },
    services: {
      label: "OUR SERVICES",
      title: "Sensory Experiences",
      subtitle: "A menu of exclusive massages, designed to awaken the senses.",
      viewAll: "View All Massages",
      details: "View Details",
      book: "Book",
      availableWith: "Available with",
    },
    essence: {
      label: "OUR ESSENCE",
      title1: "Where time",
      title2: "slows down",
      p1: "Magnolia Lunar is not just a spa — it is a sensory refuge in the heart of Lisbon. We created a sanctuary where elegance meets deep relaxation, far from the noise of the city.",
      p2: "Each therapy is a work of art performed by hand-picked therapists, combining ancient techniques with a contemporary, intuitive touch. Here, luxury lies in privacy and attention to detail.",
      privacy: "Privacy",
      privacyDesc: "Discreet, soundproofed suites",
      comfort: "Comfort",
      comfortDesc: "Premium private shower",
      cta: "Discover the Space",
    },
    testimonials: {
      title: "What our clients say",
      items: [
        { text: "A transcendental experience. The setting is impeccable and the therapist was extremely professional and attentive. Highly recommended.", author: "João M." },
        { text: "The best massage I've ever had in Lisbon. The space is very discreet and clean. The tantric massage was an incredible discovery.", author: "Ricardo S." },
        { text: "Professionalism and warmth from the very first contact. I felt completely at ease and relaxed. I will definitely return.", author: "Pedro L." },
      ],
    },
    contact: {
      label: "GET IN TOUCH",
      title: "Book your moment of peace",
      subtitle: "We are ready to welcome you to our sanctuary. Ask your questions or book your visit via WhatsApp or phone.",
      location: "Location",
      locationValue: "Av. Fontes Pereira de Melo 35",
      locationNote: "1050-118 Lisbon, Portugal",
      phone: "Phone / WhatsApp",
      phoneHours: "Open from 10am to 10pm",
      email: "Email",
      readyTitle: "Ready to relax?",
      readyDesc: "Click the button below to start a direct WhatsApp conversation. Our team will reply as soon as possible to confirm your booking.",
      whatsappCta: "Book via WhatsApp",
      availability: "Availability Today",
      fewSlots: "Few slots remaining",
    },
    booking: {
      title: "Book an Experience",
      subtitle: "Choose your masseuse and massage. We'll open a WhatsApp conversation with everything ready.",
      stepTherapist: "Choose your masseuse",
      stepMassage: "Choose the massage",
      optional: "optional",
      openWhatsApp: "Open WhatsApp",
      selectFirst: "Select a masseuse to continue",
      message: (therapist, massage) =>
        massage
          ? `Hello! I would like to book a ${massage} with masseuse ${therapist}. What is the availability?`
          : `Hello! I would like to book a session with masseuse ${therapist}. What is the availability?`,
      generalMessage: "Hello! I would like more information about the massages.",
    },
    about: {
      label: "OUR SANCTUARY",
      title: "Discover the Space",
      subtitle: "A refuge designed to provide privacy, comfort and complete sensory immersion. Every detail was designed for your relaxation.",
      howTitle: "How It Works",
      steps: [
        { title: "Choose your Experience", desc: "Browse our massages and meet our therapists to find the perfect combination for your moment." },
        { title: "Book with Discretion", desc: "Get in touch via WhatsApp. Our team will confirm availability and provide all the necessary details." },
        { title: "Relax Deeply", desc: "Upon arrival, disconnect from the outside world. Enjoy a safe, clean environment prepared for your well-being." },
      ],
      chooseTherapist: "Choose your Therapist",
      chooseTherapistDesc: "Meet some of our therapists available to make your experience unforgettable.",
    },
    therapist: {
      back: "Back to Masseuses",
      about: "About",
      gallery: "Photo Gallery",
      specialties: "Specialties",
      bookWith: "Book with",
      requestAvailability: "Request Availability",
      age: "Age",
      years: "years old",
      nationality: "Nationality",
      hair: "Hair",
      eyes: "eyes",
      height: "Height",
      weight: "Weight",
      availabilityMessage: (name) => `Hello, I would like to know ${name}'s availability.`,
    },
    massage: {
      back: "Back to Massages",
      exclusive: "EXCLUSIVE EXPERIENCE",
      specialists: "Specialized Therapists",
      bookNow: "Book Now",
      pageTitle: "Massage Menu",
    },
    therapistsPage: {
      label: "OUR TEAM",
      title: "Therapists",
      subtitle: "Meet our team of therapists specialized in sensory and tantric massages.",
    },
    footer: {
      tagline: "A sensory refuge in the heart of Lisbon. Privacy, refinement and deep relaxation.",
      navigation: "Navigation",
      massages: "Massages",
      contact: "Contact",
      hours: "Every day • 10am – 10pm",
      rights: "All rights reserved.",
      disclaimer: "Website reserved for adults over 18.",
      privacy: "Privacy",
      cookies: "Cookies",
      terms: "Terms",
      prices: "Prices",
      promotions: "Promotions",
      applications: "Careers",
      paymentsTitle: "Payments",
    },
    whatsapp: {
      float: "Chat with us on WhatsApp",
    },
    explore: {
      otherTherapists: "Other Masseuses",
      otherMassages: "Other Massages",
      previous: "Previous",
      next: "Next",
      discoverMassages: "Explore the Massage Menu",
      discoverMassagesDesc: "Tantric, Nuru, Body to Body and more — find the perfect experience for your moment.",
      discoverTherapists: "Meet the Therapists",
      discoverTherapistsDesc: "Choose the ideal professional for your experience.",
      bookCta: "Book an Experience",
      bookCtaDesc: "We'll open a WhatsApp conversation with everything ready.",
    },
    ageGate: {
      title: "Adults Only — 18+",
      text: "This website contains content intended exclusively for adults. By entering, you confirm that you are at least 18 years old.",
      confirm: "I am 18 or older — Enter",
      exit: "Leave the site",
    },
    seo: {
      home: {
        title: "Magnolia Lunar | Tantric Massage Spa in Lisbon",
        desc: "A refuge for your senses. Tantric and sensory massages in a private, sophisticated setting in the heart of Lisbon.",
      },
      therapists: {
        title: "Masseuses | Magnolia Lunar",
        desc: "Meet our team of therapists specialized in sensory and tantric massages in Lisbon.",
      },
      massages: {
        title: "Massage Menu | Magnolia Lunar",
        desc: "Explore our menu of exclusive massages in Lisbon: tantric, nuru, body to body, four hands and more.",
      },
      about: {
        title: "The Space | Magnolia Lunar",
        desc: "A sanctuary designed for privacy, comfort and complete sensory immersion in the heart of Lisbon.",
      },
      contact: {
        title: "Contact | Magnolia Lunar",
        desc: "Book your moment of peace via WhatsApp or phone. Open from 10am to 10pm in Lisbon.",
      },
    },
    cookies: {
      title: "This site uses cookies",
      body: "We only use essential cookies for the site to function and for session security. We don't use advertising cookies nor share data with third parties for marketing.",
      accept: "Got it",
      settings: "Details",
      readMore: "Read the Cookie Policy",
    },
    legal: {
      eyebrow: "LEGAL NOTICE",
      lastUpdate: "Last updated",
      updatedDate: "June 10, 2026",
      privacy: {
        seoTitle: "Privacy Policy | Magnolia Lunar",
        seoDesc: "How Magnolia Lunar Spa collects, uses and protects your personal data in accordance with GDPR.",
        title: "Privacy Policy",
        intro: "Your privacy is essential to Magnolia Lunar Spa. This document explains what data we collect, why we use it and what your rights are under GDPR.",
        sections: [
          {
            heading: "1. Data controller",
            paragraphs: [
              "The data controller is Magnolia Lunar Spa, based in Lisbon, Portugal.",
              "For any question regarding your personal data please contact us at magnolialunarspa@gmail.com or via WhatsApp +351 962 252 659.",
            ],
          },
          {
            heading: "2. Data we collect",
            paragraphs: [
              "We only collect data strictly necessary to provide the service. This includes: name, phone/WhatsApp and the messages you exchange with us when booking or requesting information. We do not ask for your address, identification documents or payment details on this website.",
              "By using the site we may also automatically collect technical data (IP address, browser type, pages visited) exclusively for security and diagnostics.",
            ],
          },
          {
            heading: "3. Purposes and legal basis",
            paragraphs: [
              "We use your data to: (i) reply to information and booking requests; (ii) confirm the reservation and provide the service; (iii) comply with applicable legal obligations; (iv) ensure the security of the site and prevent fraud.",
              "The legal bases are the performance of the contract/request, consent (where applicable) and Magnolia Lunar's legitimate interest in providing a safe, quality service.",
            ],
          },
          {
            heading: "4. Data sharing",
            paragraphs: [
              "We do not sell or share your data with third parties for marketing purposes. Bookings are initiated via WhatsApp; communication on that platform is governed by Meta Platforms Inc. policies.",
              "We may share data with technical service providers (hosting, backups) under confidentiality agreements and only to the extent necessary.",
            ],
          },
          {
            heading: "5. Retention period",
            paragraphs: [
              "We only retain data for the period necessary for the purposes for which it was collected or, where applicable, for the legal periods.",
              "Booking messages and contact history are kept for up to 24 months after the last contact, unless a legal obligation applies.",
            ],
          },
          {
            heading: "6. Your rights",
            paragraphs: [
              "Under GDPR you have the right to: access your data, rectify it, delete it, object to processing, request restriction of processing and data portability.",
              "To exercise these rights, contact us at magnolialunarspa@gmail.com. You also have the right to file a complaint with the Portuguese Data Protection Authority (CNPD — www.cnpd.pt).",
            ],
          },
          {
            heading: "7. Security",
            paragraphs: [
              "We adopt technical and organizational measures appropriate to protect data against unauthorized access, alteration, disclosure or destruction, including encrypted communications (HTTPS) and access control.",
            ],
          },
          {
            heading: "8. Changes",
            paragraphs: [
              "This policy may be updated periodically. The current version is always the one published on this page, with the date of the last update.",
            ],
          },
        ],
      },
      cookies: {
        seoTitle: "Cookie Policy | Magnolia Lunar",
        seoDesc: "Which cookies Magnolia Lunar Spa uses, what they are for and how to manage your preferences.",
        title: "Cookie Policy",
        intro: "We only use essential cookies for the site to function and for security. We do not use advertising or third-party profiling cookies.",
        sections: [
          {
            heading: "1. What are cookies?",
            paragraphs: [
              "Cookies are small text files that websites place on your device to work correctly, remember preferences or collect statistical information.",
            ],
          },
          {
            heading: "2. Which cookies do we use?",
            paragraphs: [
              "This site uses exclusively strictly necessary (essential) cookies and does not require consent under applicable legislation, although we inform you for transparency.",
              "We do not use analytics, advertising or social media cookies.",
            ],
          },
          {
            heading: "3. How to manage cookies?",
            paragraphs: [
              "You can manage or delete cookies at any time through your browser settings. If you block essential cookies, some areas of the site (such as the admin panel) may stop working correctly.",
            ],
          },
          {
            heading: "4. Cookies in detail",
            paragraphs: [
              "Below is the list of cookies and local storage items used by this site.",
            ],
          },
        ],
        tableName: "Name",
        tablePurpose: "Purpose",
        tableDuration: "Duration",
        tableType: "Type",
        table: [
          { name: "access_token", purpose: "Authenticated session in the admin panel (httpOnly)", duration: "15 minutes", type: "Essential" },
          { name: "refresh_token", purpose: "Renewal of the admin session (httpOnly)", duration: "7 days", type: "Essential" },
          { name: "ml-lang", purpose: "Preferred language (PT/EN/ES) — localStorage", duration: "Persistent", type: "Essential" },
          { name: "ml-theme", purpose: "Visual theme (light/dark) — localStorage", duration: "Persistent", type: "Essential" },
          { name: "ml-age-ok", purpose: "18+ age confirmation — localStorage", duration: "Persistent", type: "Essential" },
          { name: "ml-cookie-consent-v1", purpose: "Confirmation of the cookie notice — localStorage", duration: "Persistent", type: "Essential" },
        ],
      },
      terms: {
        seoTitle: "Terms & Conditions | Magnolia Lunar",
        seoDesc: "Conditions of use of the site and of the bookings made with Magnolia Lunar Spa.",
        title: "Terms & Conditions",
        intro: "By using this website you accept the terms and conditions described below. If you do not agree with any part, please do not use the site.",
        sections: [
          {
            heading: "1. Purpose and scope",
            paragraphs: [
              "This site is owned by Magnolia Lunar Spa, based in Lisbon, Portugal, and is intended exclusively for adults (18+). It is used to present our sensory and tantric massage services and allow contact and booking.",
            ],
          },
          {
            heading: "2. Minimum age (18+)",
            paragraphs: [
              "Access to the website and services is reserved for people aged 18 or over. By entering, you confirm this. We reserve the right to refuse service to anyone who does not meet this requirement.",
            ],
          },
          {
            heading: "3. Nature of the services",
            paragraphs: [
              "The massages practiced at Magnolia Lunar are of a sensory, relaxing and tantric nature. They are not sexual services, escort or prostitution. Any interpretation to the contrary is the sole responsibility of the visitor.",
            ],
          },
          {
            heading: "4. Booking and cancellation",
            paragraphs: [
              "Bookings are made via WhatsApp and are only confirmed after validation by our team. You may be asked to reschedule if the chosen therapist is unavailable.",
              "We ask that cancellations be communicated at least 3 hours in advance.",
            ],
          },
          {
            heading: "5. Behavior on premises",
            paragraphs: [
              "Respect and courtesy toward all therapists and staff are required. Any inappropriate or offensive behavior, or behavior that exceeds the limits of the service provided, will result in the immediate termination of the service without refund.",
            ],
          },
          {
            heading: "6. Intellectual property",
            paragraphs: [
              "All content of the site (texts, images, logo, brand, code) is the property of Magnolia Lunar Spa or its respective owners. Total or partial reproduction without written permission is prohibited.",
            ],
          },
          {
            heading: "7. Limitation of liability",
            paragraphs: [
              "Magnolia Lunar strives to keep the site's information correct and up to date, but does not guarantee the absence of errors, delays or interruptions. We are not liable for damages arising from the use or inability to use the site.",
            ],
          },
          {
            heading: "8. Applicable law and jurisdiction",
            paragraphs: [
              "These terms are governed by Portuguese law. To resolve any dispute, the parties elect the Court of Lisbon, expressly waiving any other.",
            ],
          },
        ],
      },
    },
    applications: {
      label: "JOIN OUR TEAM",
      title: "Want to work with us?",
      subtitle: "Join the Magnolia Lunar Spa team. We provide training in our massage techniques.",
      whatsapp: "Message us on WhatsApp",
      formTitle: "Or fill out the form below",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      messagePlaceholder: "Tell us about yourself (age, experience, availability...)",
      photo1: "Photo 1 (face)",
      photo2: "Photo 2 (full body)",
      photo3: "Photo 3 or CV",
      photoHint: "Max 10 MB per file",
      submit: "Send application",
      submitting: "Sending...",
      successTitle: "Application sent!",
      successText: "Thank you for your interest. We will review your application and contact you shortly.",
      profileTitle: "Who we're looking for",
      profileText: "Magnolia Lunar Spa is dedicated to sensory and tantric massage. Our clients are women, men and couples looking to relax in a unique experience.",
      profileBullets: [
        "With or without prior massage experience",
        "Open-minded and focused on 5-star service",
        "Good physical presentation",
        "Good learning ability",
        "Discretion and professionalism",
      ],
      profileClose: "If this sounds like you, come work with us.",
      requiredError: "Please fill in all required fields.",
      emailError: "Invalid email.",
      phoneError: "Invalid phone. Enter 9 digits starting with 9.",
      phoneHint: "9 digits, e.g. 912345678",
      sendError: "Could not send your application. Please try again.",
    },
    promotions: {
      label: "PROMOTIONS & NEWSLETTER",
      title: "Exclusive promotions",
      subtitle: "Enter your email and receive our promotions.",
      emailPlaceholder: "Your email",
      subscribe: "Subscribe",
      subscribing: "Subscribing...",
      successTitle: "Subscription confirmed!",
      successText: "Welcome to the Magnolia Lunar newsletter. Keep an eye on your inbox.",
      alreadyText: "This email is already subscribed.",
      benefitsTitle: "What you'll get",
      benefits: [
        "Exclusive discounts on relaxing, tantric and sensory massages",
        "Special promotions on couple and individual packages",
        "Early news on treatments and services",
        "Invitations to unique wellness events and experiences",
      ],
      privacyNote: "Your privacy is respected. You can unsubscribe at any time.",
      emailError: "Invalid email.",
      sendError: "Could not subscribe. Please try again.",
    },
    prices: {
      label: "PRICE LIST",
      title: "Prices",
      subtitle: "Personalized 5-star service in a modern, discreet setting.",
      individualTitle: "Individual massages",
      individualFrom: "From",
      individualPrice: "€40",
      coupleTitle: "Couples massages",
      coupleFrom: "From",
      couplePrice: "€250",
      note: "We offer many combinations of massages and add-ons, with promotions available. For details or to book, contact us via WhatsApp or phone.",
      ctaWhatsapp: "Chat on WhatsApp",
      paymentsTitle: "Accepted payment methods",
      viewMassages: "View all massages",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      therapists: "Masajistas",
      massages: "Masajes",
      about: "El Espacio",
      contact: "Contacto",
      book: "Reservar",
      allTherapists: "Ver todas las masajistas",
      allMassages: "Ver todos los masajes",
      applications: "Trabaja Connosco",
      promotions: "Promociones",
      prices: "Precios",
    },
    hero: {
      label: "MAGNOLIA LUNAR • LISBOA",
      title1: "Un refugio para",
      title2: "tus sentidos",
      subtitle: "Masajes sensoriales en un ambiente reservado y sofisticado. Un día relajante para cuerpo, mente y sentidos.",
      ctaBook: "Reservar Experiencia",
      ctaExplore: "Explorar Masajes",
      scroll: "Desliza para descubrir",
    },
    team: {
      label: "EQUIPO",
      title: "Nuestras Terapeutas",
      subtitle: "Profesionales dedicadas a proporcionar una experiencia única de relajación y conexión.",
      viewAll: "Conocer a Todo el Equipo",
      bookWith: "Reservar con",
      viewProfile: "Ver Perfil",
      availableToday: "Disponible Hoy",
    },
    services: {
      label: "NUESTROS SERVICIOS",
      title: "Experiencias Sensoriales",
      subtitle: "Un menú de masajes exclusivos, diseñado para despertar los sentidos.",
      viewAll: "Ver Todos los Masajes",
      details: "Ver Detalles",
      book: "Reservar",
      availableWith: "Disponible con",
    },
    essence: {
      label: "NUESTRA ESENCIA",
      title1: "Donde el tiempo",
      title2: "se detiene",
      p1: "Magnolia Lunar no es solo un spa, es un refugio sensorial en el corazón de Lisboa. Creamos un santuario donde la elegancia se encuentra con la relajación profunda, lejos del ruido de la ciudad.",
      p2: "Cada terapia es una obra de arte ejecutada por terapeutas seleccionadas, combinando técnicas milenarias con un toque contemporáneo e intuitivo. Aquí, el lujo reside en la privacidad y la atención al detalle.",
      privacy: "Privacidad",
      privacyDesc: "Suites acústicas y discretas",
      comfort: "Confort",
      comfortDesc: "Ducha privada premium",
      cta: "Conoce el Espacio",
    },
    testimonials: {
      title: "Lo que dicen nuestros clientes",
      items: [
        { text: "Una experiencia trascendental. El ambiente es impecable y la terapeuta fue extremadamente profesional y atenta. Lo recomiendo vivamente.", author: "João M." },
        { text: "El mejor masaje que he recibido en Lisboa. El espacio es muy discreto y limpio. El masaje tántrico fue un descubrimiento increíble.", author: "Ricardo S." },
        { text: "Profesionalidad y simpatía desde el primer contacto. Me sentí muy cómodo y relajado. Volveré sin duda.", author: "Pedro L." },
      ],
    },
    contact: {
      label: "PONTE EN CONTACTO",
      title: "Reserva tu momento de paz",
      subtitle: "Estamos listos para recibirte en nuestro santuario. Resuelve tus dudas o reserva tu visita por WhatsApp o teléfono.",
      location: "Ubicación",
      locationValue: "Av. Fontes Pereira de Melo 35",
      locationNote: "1050-118 Lisboa, Portugal",
      phone: "Teléfono / WhatsApp",
      phoneHours: "Atención de 10h a 22h",
      email: "Email",
      readyTitle: "¿Listo para relajarte?",
      readyDesc: "Haz clic en el botón de abajo para iniciar una conversación directa por WhatsApp. Nuestro equipo responderá lo antes posible para confirmar tu reserva.",
      whatsappCta: "Reservar por WhatsApp",
      availability: "Disponibilidad Hoy",
      fewSlots: "Pocas plazas restantes",
    },
    booking: {
      title: "Reservar Experiencia",
      subtitle: "Elige tu masajista y el masaje. Abriremos una conversación de WhatsApp con todo preparado.",
      stepTherapist: "Elige la masajista",
      stepMassage: "Elige el masaje",
      optional: "opcional",
      openWhatsApp: "Abrir WhatsApp",
      selectFirst: "Selecciona una masajista para continuar",
      message: (therapist, massage) =>
        massage
          ? `¡Hola! Me gustaría reservar un ${massage} con la masajista ${therapist}. ¿Cuál es la disponibilidad?`
          : `¡Hola! Me gustaría reservar una sesión con la masajista ${therapist}. ¿Cuál es la disponibilidad?`,
      generalMessage: "¡Hola! Me gustaría obtener más información sobre los masajes.",
    },
    about: {
      label: "NUESTRO SANTUARIO",
      title: "Conoce el Espacio",
      subtitle: "Un refugio diseñado para proporcionar privacidad, confort y una inmersión sensorial completa. Cada detalle fue pensado para tu relajación.",
      howTitle: "Cómo Funciona",
      steps: [
        { title: "Elige tu Experiencia", desc: "Navega por nuestros masajes y conoce a nuestras terapeutas para encontrar la combinación perfecta para tu momento." },
        { title: "Reserva con Discreción", desc: "Contáctanos por WhatsApp. Nuestro equipo confirmará la disponibilidad y proporcionará todos los detalles necesarios." },
        { title: "Relájate Profundamente", desc: "Al llegar, desconéctate del mundo exterior. Disfruta de un ambiente seguro, limpio y preparado para tu bienestar." },
      ],
      chooseTherapist: "Elige a tu Terapeuta",
      chooseTherapistDesc: "Conoce a algunas de nuestras terapeutas disponibles para hacer tu experiencia inolvidable.",
    },
    therapist: {
      back: "Volver a Masajistas",
      about: "Sobre",
      gallery: "Galería de Fotos",
      specialties: "Especialidades",
      bookWith: "Reserva con",
      requestAvailability: "Solicitar Disponibilidad",
      age: "Edad",
      years: "años",
      nationality: "Nacionalidad",
      hair: "Cabello",
      eyes: "ojos",
      height: "Altura",
      weight: "Peso",
      availabilityMessage: (name) => `Hola, me gustaría saber la disponibilidad de ${name}.`,
    },
    massage: {
      back: "Volver a Masajes",
      exclusive: "EXPERIENCIA EXCLUSIVA",
      specialists: "Terapeutas Especializadas",
      bookNow: "Reservar Ahora",
      pageTitle: "Menú de Masajes",
    },
    therapistsPage: {
      label: "NUESTRO EQUIPO",
      title: "Terapeutas",
      subtitle: "Conoce a nuestro equipo de terapeutas especializadas en masajes sensoriales y tántricos.",
    },
    footer: {
      tagline: "Un refugio sensorial en el corazón de Lisboa. Privacidad, refinamiento y relajación profunda.",
      navigation: "Navegación",
      massages: "Masajes",
      contact: "Contacto",
      hours: "Todos los días • 10h – 22h",
      rights: "Todos los derechos reservados.",
      disclaimer: "Sitio web reservado para mayores de 18 años.",
      privacy: "Privacidad",
      cookies: "Cookies",
      terms: "Términos",
      prices: "Precios",
      promotions: "Promociones",
      applications: "Trabaja Con Nosotros",
      paymentsTitle: "Pagos",
    },
    whatsapp: {
      float: "Habla con nosotros por WhatsApp",
    },
    explore: {
      otherTherapists: "Otras Masajistas",
      otherMassages: "Otros Masajes",
      previous: "Anterior",
      next: "Siguiente",
      discoverMassages: "Explorar el Menú de Masajes",
      discoverMassagesDesc: "Tántrico, Nuru, Cuerpo a Cuerpo y más — descubre la experiencia perfecta para tu momento.",
      discoverTherapists: "Conocer a las Terapeutas",
      discoverTherapistsDesc: "Elige a la profesional ideal para tu experiencia.",
      bookCta: "Reservar Experiencia",
      bookCtaDesc: "Abrimos una conversación de WhatsApp con todo preparado.",
    },
    ageGate: {
      title: "Sitio Reservado a Mayores de 18",
      text: "Este sitio web contiene contenido destinado exclusivamente a adultos. Al entrar, confirmas que tienes al menos 18 años de edad.",
      confirm: "Tengo 18 años o más — Entrar",
      exit: "Salir del sitio",
    },
    seo: {
      home: {
        title: "Magnolia Lunar | Spa de Masajes Tántricos en Lisboa",
        desc: "Un refugio para tus sentidos. Masajes tántricos y sensoriales en un ambiente reservado y sofisticado en el corazón de Lisboa.",
      },
      therapists: {
        title: "Masajistas | Magnolia Lunar",
        desc: "Conoce a nuestro equipo de terapeutas especializadas en masajes sensoriales y tántricos en Lisboa.",
      },
      massages: {
        title: "Menú de Masajes | Magnolia Lunar",
        desc: "Explora nuestro menú de masajes exclusivos en Lisboa: tántrico, nuru, cuerpo a cuerpo, 4 manos y más.",
      },
      about: {
        title: "El Espacio | Magnolia Lunar",
        desc: "Un santuario diseñado para privacidad, confort e inmersión sensorial completa en el corazón de Lisboa.",
      },
      contact: {
        title: "Contacto | Magnolia Lunar",
        desc: "Reserva tu momento de paz por WhatsApp o teléfono. Atención de 10h a 22h en Lisboa.",
      },
    },
    cookies: {
      title: "Este sitio usa cookies",
      body: "Utilizamos únicamente cookies esenciales para el funcionamiento del sitio y la seguridad de la sesión. No usamos cookies publicitarias ni compartimos datos con terceros para marketing.",
      accept: "Entendido",
      settings: "Detalles",
      readMore: "Leer la Política de Cookies",
    },
    legal: {
      eyebrow: "AVISO LEGAL",
      lastUpdate: "Última actualización",
      updatedDate: "10 de junio de 2026",
      privacy: {
        seoTitle: "Política de Privacidad | Magnolia Lunar",
        seoDesc: "Cómo Magnolia Lunar Spa recoge, utiliza y protege tus datos personales conforme al RGPD.",
        title: "Política de Privacidad",
        intro: "Tu privacidad es esencial para Magnolia Lunar Spa. Este documento explica qué datos recogemos, para qué los usamos y cuáles son tus derechos según el RGPD.",
        sections: [
          {
            heading: "1. Responsable del tratamiento",
            paragraphs: [
              "El responsable del tratamiento de los datos personales es Magnolia Lunar Spa, con sede en Lisboa, Portugal.",
              "Para cualquier cuestión relacionada con tus datos personales, contáctanos en magnolialunarspa@gmail.com o por WhatsApp +351 962 252 659.",
            ],
          },
          {
            heading: "2. Datos que recogemos",
            paragraphs: [
              "Solo recogemos los datos estrictamente necesarios para prestar el servicio: nombre, teléfono/WhatsApp y los mensajes intercambiados al hacer una reserva o pedir información. No solicitamos dirección, documentos de identificación ni datos de pago en este sitio.",
              "Al usar el sitio también podemos recoger datos técnicos automáticos (dirección IP, tipo de navegador, páginas visitadas) exclusivamente para fines de seguridad y diagnóstico.",
            ],
          },
          {
            heading: "3. Finalidades y base legal",
            paragraphs: [
              "Utilizamos tus datos para: (i) responder a solicitudes de información y reserva; (ii) confirmar la reserva y prestar el servicio; (iii) cumplir obligaciones legales aplicables; (iv) garantizar la seguridad del sitio y prevenir fraudes.",
              "Las bases legales son la ejecución del contrato/solicitud, el consentimiento (cuando aplicable) y el interés legítimo de Magnolia Lunar en prestar un servicio seguro y de calidad.",
            ],
          },
          {
            heading: "4. Compartición de datos",
            paragraphs: [
              "No vendemos ni compartimos tus datos con terceros con fines de marketing. Las reservas se inician por WhatsApp; la comunicación en esa plataforma se rige por las políticas de Meta Platforms Inc.",
              "Podemos compartir datos con proveedores de servicios técnicos (alojamiento, copias de seguridad) bajo acuerdos de confidencialidad y solo en la medida necesaria.",
            ],
          },
          {
            heading: "5. Plazo de conservación",
            paragraphs: [
              "Conservamos los datos solo durante el tiempo necesario para las finalidades para las que fueron recogidos o, cuando aplicable, durante los plazos legales.",
              "Los mensajes de reserva y el historial de contactos se conservan hasta 24 meses tras el último contacto, salvo obligación legal en contrario.",
            ],
          },
          {
            heading: "6. Tus derechos",
            paragraphs: [
              "Al amparo del RGPD tienes derecho a: acceder a tus datos, rectificarlos, suprimirlos, oponerte al tratamiento, solicitar la limitación del tratamiento y la portabilidad.",
              "Para ejercer estos derechos escríbenos a magnolialunarspa@gmail.com. También tienes derecho a presentar una reclamación ante la autoridad portuguesa de protección de datos (CNPD — www.cnpd.pt).",
            ],
          },
          {
            heading: "7. Seguridad",
            paragraphs: [
              "Adoptamos medidas técnicas y organizativas adecuadas para proteger los datos contra el acceso no autorizado, alteración, divulgación o destrucción, incluyendo comunicaciones cifradas (HTTPS) y control de accesos.",
            ],
          },
          {
            heading: "8. Cambios",
            paragraphs: [
              "Esta política puede actualizarse periódicamente. La versión en vigor es siempre la publicada en esta página, con la fecha de última actualización.",
            ],
          },
        ],
      },
      cookies: {
        seoTitle: "Política de Cookies | Magnolia Lunar",
        seoDesc: "Qué cookies utiliza Magnolia Lunar Spa, para qué sirven y cómo gestionar tus preferencias.",
        title: "Política de Cookies",
        intro: "Utilizamos únicamente cookies esenciales para el funcionamiento y la seguridad del sitio. No usamos cookies publicitarias ni de perfilado de terceros.",
        sections: [
          {
            heading: "1. ¿Qué son las cookies?",
            paragraphs: [
              "Las cookies son pequeños archivos de texto que los sitios web colocan en tu dispositivo para funcionar correctamente, recordar preferencias o recoger información estadística.",
            ],
          },
          {
            heading: "2. ¿Qué cookies usamos?",
            paragraphs: [
              "Este sitio utiliza exclusivamente cookies estrictamente necesarias (esenciales) y no requiere consentimiento según la legislación aplicable, aunque te informamos por transparencia.",
              "No utilizamos cookies analíticas, publicitarias ni de redes sociales.",
            ],
          },
          {
            heading: "3. ¿Cómo gestionar las cookies?",
            paragraphs: [
              "Puedes gestionar o eliminar las cookies en cualquier momento desde la configuración de tu navegador. Si bloqueas las cookies esenciales, algunas áreas del sitio (como el panel de administración) pueden dejar de funcionar correctamente.",
            ],
          },
          {
            heading: "4. Cookies en detalle",
            paragraphs: [
              "A continuación, la lista de cookies y elementos de almacenamiento local utilizados por este sitio.",
            ],
          },
        ],
        tableName: "Nombre",
        tablePurpose: "Finalidad",
        tableDuration: "Duración",
        tableType: "Tipo",
        table: [
          { name: "access_token", purpose: "Sesión autenticada en el panel de administración (httpOnly)", duration: "15 minutos", type: "Esencial" },
          { name: "refresh_token", purpose: "Renovación de la sesión de administración (httpOnly)", duration: "7 días", type: "Esencial" },
          { name: "ml-lang", purpose: "Idioma preferido (PT/EN/ES) — localStorage", duration: "Persistente", type: "Esencial" },
          { name: "ml-theme", purpose: "Tema visual (claro/oscuro) — localStorage", duration: "Persistente", type: "Esencial" },
          { name: "ml-age-ok", purpose: "Confirmación de mayoría de edad 18+ — localStorage", duration: "Persistente", type: "Esencial" },
          { name: "ml-cookie-consent-v1", purpose: "Confirmación del aviso de cookies — localStorage", duration: "Persistente", type: "Esencial" },
        ],
      },
      terms: {
        seoTitle: "Términos y Condiciones | Magnolia Lunar",
        seoDesc: "Condiciones de uso del sitio y de las reservas realizadas con Magnolia Lunar Spa.",
        title: "Términos y Condiciones",
        intro: "Al utilizar este sitio web aceptas los términos y condiciones descritos a continuación. Si no estás de acuerdo con alguna parte, no utilices el sitio.",
        sections: [
          {
            heading: "1. Objeto y ámbito",
            paragraphs: [
              "Este sitio es propiedad de Magnolia Lunar Spa, con sede en Lisboa, Portugal, y está destinado exclusivamente a mayores de 18 años. Sirve para presentar nuestros servicios de masajes sensoriales y tántricos y permitir el contacto y la reserva.",
            ],
          },
          {
            heading: "2. Edad mínima (18+)",
            paragraphs: [
              "El acceso al sitio y a los servicios está reservado a mayores de 18 años. Al entrar, confirmas esta condición. Nos reservamos el derecho de rechazar el servicio a quien no cumpla este requisito.",
            ],
          },
          {
            heading: "3. Naturaleza de los servicios",
            paragraphs: [
              "Los masajes que se practican en Magnolia Lunar son de naturaleza sensorial, relajante y tántrica. No son servicios sexuales, de acompañamiento ni prostitución. Cualquier interpretación en contrario es responsabilidad exclusiva del visitante.",
            ],
          },
          {
            heading: "4. Reserva y cancelación",
            paragraphs: [
              "Las reservas se realizan por WhatsApp y solo se confirman tras la validación de nuestro equipo. Podrá solicitarse una modificación si la terapeuta elegida no está disponible.",
              "Pedimos que las cancelaciones se comuniquen con al menos 3 horas de antelación.",
            ],
          },
          {
            heading: "5. Comportamiento en el espacio",
            paragraphs: [
              "Se exige respeto y educación hacia todas las terapeutas y colaboradores. Cualquier comportamiento inadecuado u ofensivo, o que exceda los límites del servicio, conllevará la interrupción inmediata del mismo sin derecho a reembolso.",
            ],
          },
          {
            heading: "6. Propiedad intelectual",
            paragraphs: [
              "Todo el contenido del sitio (textos, imágenes, logotipo, marca, código) es propiedad de Magnolia Lunar Spa o de sus respectivos titulares. Queda prohibida la reproducción total o parcial sin autorización por escrito.",
            ],
          },
          {
            heading: "7. Limitación de responsabilidad",
            paragraphs: [
              "Magnolia Lunar se esfuerza por mantener la información del sitio correcta y actualizada, pero no garantiza la ausencia de errores, retrasos o interrupciones. No nos responsabilizamos por los daños derivados del uso o la imposibilidad de uso del sitio.",
            ],
          },
          {
            heading: "8. Ley aplicable y jurisdicción",
            paragraphs: [
              "Estos términos se rigen por la ley portuguesa. Para resolver cualquier litigio, las partes eligen el foro de Lisboa, renunciando expresamente a cualquier otro.",
            ],
          },
        ],
      },
    },
    applications: {
      label: "TRABAJA CON NOSOTROS",
      title: "¿Quieres trabajar con nosotros?",
      subtitle: "Únete al equipo del Magnolia Lunar Spa. Damos formación en nuestras técnicas de masaje.",
      whatsapp: "Envíanos un mensaje por WhatsApp",
      formTitle: "O rellena el formulario abajo",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      message: "Mensaje",
      messagePlaceholder: "Cuéntanos sobre ti (edad, experiencia, disponibilidad...)",
      photo1: "Foto 1 (rostro)",
      photo2: "Foto 2 (cuerpo entero)",
      photo3: "Foto 3 o CV",
      photoHint: "Máx. 10 MB por archivo",
      submit: "Enviar candidatura",
      submitting: "Enviando...",
      successTitle: "¡Candidatura enviada!",
      successText: "Gracias por tu interés. Revisaremos tu candidatura y te contactaremos pronto.",
      profileTitle: "A quién buscamos",
      profileText: "El Magnolia Lunar Spa está dedicado al masaje sensorial y tántrico. Nuestros clientes son mujeres, hombres y parejas que nos buscan para relajarse en una experiencia única.",
      profileBullets: [
        "Con o sin experiencia previa en masaje",
        "Mente abierta y orientada a un servicio 5 estrellas",
        "Buena presentación física",
        "Buena capacidad de aprendizaje",
        "Discreción y profesionalismo",
      ],
      profileClose: "Si tienes este perfil, ven a trabajar con nosotros.",
      requiredError: "Por favor rellena todos los campos obligatorios.",
      emailError: "Email inválido.",
      phoneError: "Teléfono inválido. Introduce 9 dígitos empezando por 9.",
      phoneHint: "9 dígitos, ej. 912345678",
      sendError: "No se pudo enviar la candidatura. Inténtalo de nuevo.",
    },
    promotions: {
      label: "PROMOCIONES Y NEWSLETTER",
      title: "Promociones exclusivas",
      subtitle: "Introduce tu email y recibe nuestras promociones.",
      emailPlaceholder: "Tu email",
      subscribe: "Suscribirse",
      subscribing: "Suscribiendo...",
      successTitle: "¡Suscripción confirmada!",
      successText: "Bienvenido/a a la newsletter del Magnolia Lunar. Estate atento/a a tu bandeja de entrada.",
      alreadyText: "Este email ya está suscrito.",
      benefitsTitle: "Lo que recibirás",
      benefits: [
        "Descuentos exclusivos en masajes relajantes, tántricos y sensoriales",
        "Promociones especiales en paquetes de pareja o individuales",
        "Novedades anticipadas sobre tratamientos y servicios",
        "Invitaciones a eventos y experiencias de bienestar únicas",
      ],
      privacyNote: "Tu privacidad es respetada. Puedes darte de baja en cualquier momento.",
      emailError: "Email inválido.",
      sendError: "No se pudo suscribir. Inténtalo de nuevo.",
    },
    prices: {
      label: "TABLA DE PRECIOS",
      title: "Precios",
      subtitle: "Servicio personalizado 5 estrellas en un ambiente moderno y discreto.",
      individualTitle: "Masajes individuales",
      individualFrom: "Desde",
      individualPrice: "40€",
      coupleTitle: "Masajes de pareja",
      coupleFrom: "Desde",
      couplePrice: "250€",
      note: "Ofrecemos muchas combinaciones de masajes y complementos, con promociones vigentes. Para más detalles o reservar, contáctanos por WhatsApp o teléfono.",
      ctaWhatsapp: "Hablar por WhatsApp",
      paymentsTitle: "Métodos de pago aceptados",
      viewMassages: "Ver todos los masajes",
    },
  },
};
